/// <amd-module name="Widgets/VSLinksWidget/VSLinksWidget" />
import * as WidgetTelemetry from "Dashboards/WidgetCommon/WidgetTelemetry";
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { VisualTitle } from "Reporting/Visuals/VisualTitle";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import { VssComponent } from "VSS/Platform/Layout";
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import { Link } from "VSSUI/Link";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import * as Resources from "Widgets/VSLinksWidget/Resources";

export class VSLinksWidget extends VssComponent<WidgetProps, {}> {
    public static componentType = "vsLinksWidget";

    public componentDidMount(): void {
        this.props.onWidgetLoaded();
        WidgetTelemetry.onWidgetLoaded(this.context.pageContext, this.props);
    }

    public render(): JSX.Element {
        return (
            <div>
                <VisualTitle text={Resources.Title} />
                <div className={"widget visual-studio-links"}>{this.renderContent()}</div>
            </div>
        );
    }

    public renderContent(): JSX.Element {
        const vssPageService: IVssPageService = this.context.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = vssPageService.getData() as IPageData;
        const collectionUri = location.origin + pageData.hostPath;

        const projectId = TfsWidgetContext.getProject(this.context.pageContext).id;

        // Encode the URI to deal with any non-utf8 character
        const tfsLink = `vstfs:///Framework/TeamProject/${projectId}?url=${encodeURI(collectionUri)}`;
        const vsOpenLinkUrl = "vsweb://vs/?Product=Visual_Studio\u0026EncFormat=UTF8\u0026tfslink=" + window.btoa(tfsLink);

        return (
            <ul className={"link-with-icon-text-list"}>
                {// 'Open Visual Studio' link.
                this.renderVSLinkListItem(vsOpenLinkUrl, Resources.VSOpenLink_Title, Resources.VSOpenLink_SubTitle, "ReplyMirrored", "openvs", {
                    tooltipText: Resources.VSOpenLink_Tooltip
                })}
                {// 'Get Visual Studio' link.
                this.renderVSLinkListItem(
                    Resources.VSDownloadLink,
                    Resources.VSDownloadLink_Title,
                    Resources.VSDownloadLink_SubTitle,
                    "VisualStudioLogo",
                    "getvs",
                    { openInNewPage: true }
                )}
            </ul>
        );
    }

    private renderVSLinkListItem(
        url: string,
        title: string,
        subtitle: string,
        iconName: string,
        iconClassName: string,
        options?: { openInNewPage?: boolean; tooltipText?: string }
    ): JSX.Element {
        return (
            <li>
                <Link
                    href={url}
                    className={"link-with-icon-text"}
                    target={options && options.openInNewPage ? "_blank" : ""}
                    tooltipProps={{
                        overflowOnly: true,
                        showOnFocus: true,
                        text: options && options.tooltipText ? options.tooltipText : ""
                    }}
                >
                    <span className={iconClassName + " icon-container"}>
                        <VssIcon iconName={iconName} iconType={VssIconType.fabric} />
                    </span>
                    <div className={"title"}>
                        {title}
                        <div className={"subtitle"}>{subtitle}</div>
                    </div>
                </Link>
            </li>
        );
    }
}

VssComponent.register(VSLinksWidget.componentType, VSLinksWidget);
